export default "__VITE_ASSET__BNF719z$__"